import React, {useEffect, useState} from 'react';
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import {IGaugeChartKey} from '@src/types';
import '@components/module-components/consumptionLineChart/line-chart.scss';
import {useSelector} from 'react-redux';
import {Translations} from '@constants/translate';
import {translate} from '@src/helpers';
import closeIcon from '@assets/images/icons/close-light.svg'


interface ILineChartData {
  process_name: string
  process_position: string
  water: number
  carbon: number
  energy: number
}

const ConsumptionChart = ({ lineData, onClose }: any) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any;
  const defaultLineChartData = [] as ILineChartData[];
  const [ lChartData, setLChartData ] = useState([...defaultLineChartData]);
  const [ isDisabled, setIsDisabled ] = useState({
    water: false,
    carbon: false,
    energy: false
  });

  useEffect(() => {
    console.log(lineData);
    const orderSummary = async() => {
      const lcData = lineData.map((item:any) => {
        const data = { process_name: item.process_name, process_position: item.process_position_b2c } as any;
        item.echo_score.map((item:any) => data[item.type] = item.recorded);
        return ({
          ...data
        });
      });

      setLChartData([
        {},
        ...lcData,
        {}
      ]);
    }

    orderSummary();
  }, [lineData]);

  const handleClick  = (e:any) => {
    const key = e.dataKey as IGaugeChartKey;

    setIsDisabled({
      ...isDisabled,
      [e.dataKey]: !isDisabled[key]
    });
  }

  const CustomTooltip = ({ active, payload, label }: any) => {
    const process = lChartData.find(cData => cData.process_position === label);
    if (active) {
      return (
        <div className="recharts-default-tooltip">
          <p className="recharts-tooltip-label">{process && process.process_name}</p>
          <ul className="recharts-tooltip-item-list">
            {
              payload && payload.length > 0 && payload.map((record: any, idx: number) =>
                <li key={`record-chart-${idx}`} className="recharts-tooltip-item" style={{color: record.color}}>
                  <span className="recharts-tooltip-item-name">{record.name}</span><span className="recharts-tooltip-item-separator"> : </span><span className="recharts-tooltip-item-value">{record.value}</span><span className="recharts-tooltip-item-unit"></span>
                </li>
               )
            }
          </ul>
        </div>
      );
    }

    return null;
  };

  return (
    <>
    <div className="modal-backdrop fade show"></div>
    <div className="modal chartModal fade show">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{translate(langData.localize, Translations["B2C.TITLE.ECO_SCORE_DETAIL"])}</h5>
            <button type="button" className="close" onClick={onClose}>
              <img src={closeIcon} alt=""/>
            </button>
          </div>
          <div className="modal-body">
            <ResponsiveContainer width="100%" height={300}>
              <LineChart
                data={lChartData}
                margin={{
                  top: 20, right: 0, left: 0, bottom: 20,
                }}
                throttleDelay={10}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="process_position" tick={(!isDisabled.carbon || !isDisabled.energy || !isDisabled.water)} dy={5} />
                <YAxis yAxisId="first" type="number" dataKey="carbon" stroke="#2ed865" tick={!isDisabled.carbon} width={30}/>
                <YAxis yAxisId="second" type="number" dataKey="energy" orientation="left" stroke="#ffa16c" tick={!isDisabled.energy}  width={30} />
                <YAxis yAxisId="third" type="number" dataKey="water" orientation="right" stroke="#76ddfb" tick={!isDisabled.water}  width={30}/>
                <Tooltip content={<CustomTooltip />}/>
                <Legend verticalAlign="top" align="right" onClick={handleClick} wrapperStyle={{fontSize: 12, top: 10}}/>
                <Line yAxisId="first" type="linear" name={translate(langData.localize, Translations["FIP.BRAND.ORDER.CO2_EMISSION"])} dataKey="carbon" stroke="#2ed865" hide={isDisabled.carbon}/>
                <Line yAxisId="second" type="linear" name={translate(langData.localize, Translations["FIP.BRAND.ORDER.ENERGY_USED"])} dataKey="energy" stroke="#ffa16c"  hide={isDisabled.energy}/>
                <Line yAxisId="third" type="linear" name={translate(langData.localize, Translations["FIP.BRAND.ORDER.WATER_USED"])} dataKey="water" stroke="#76ddfb"  hide={isDisabled.water}/>
              </LineChart>
            </ResponsiveContainer>
            <ul className="consumption-list">
              {
                lineData.map((list: any) =>
                <li className="consumption-list_item" key={`consumption-list-${list.process_position_b2c}`}>
                  <div className="consumption-list_position">{list.process_position_b2c}</div>
                  <div className="consumption-list_name">{list.process_name}</div>
                </li>
                )
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}

export default ConsumptionChart;
